import {unmockedGraphQlOperationsStore} from 'src/test/shared/store';

import type {GqlError} from 'src/internal/revamp/graphql/GqlError';
import type Headerz from 'src/internal/shared/headers/headers';
import type {GraphQlMockDataInput} from 'src/test/globalGraphQlMocks';
import type {MockStore} from 'src/test/shared/store';
import type {FetchOptions, GraphQlResponseError} from 'src/types';

export type GraphQlMockResponseWithTypedErrors<TData, TErrorExtensions> = {
  errors?: Array<GqlError<TErrorExtensions>> | null;
  data?: TData | null;
};

export type FetchTextResponseMock = {
  body: string;
  headers?: Headerz | {[name: string]: string | string[]};
  status?: number;
};

export type GraphQlMockOptions<TVariables> = {
  variables: TVariables;
};

export type GraphQlMockResponseWithUntypedErrors<TData> = {
  data?: TData | null;
  error?: never; // Prevent a common mistake
  errors?: Array<GraphQlResponseError>;
};

export type GraphQlMockResponse<TData, TErrorExtensions = never> = [
  TErrorExtensions,
] extends [never]
  ? GraphQlMockResponseWithUntypedErrors<TData>
  : GraphQlMockResponseWithTypedErrors<TData, TErrorExtensions>;

export type GraphQlMockInputResponse<TData, TErrorExtensions = never> = [
  TErrorExtensions,
] extends [never]
  ? GraphQlMockResponseWithUntypedErrors<GraphQlMockDataInput<TData>>
  : GraphQlMockResponseWithTypedErrors<
      GraphQlMockDataInput<TData>,
      TErrorExtensions
    >;

type StorageCallback = (name: string, value: string | null) => void;

export const fetchMockStore: MockStore<
  FetchOptions,
  FetchTextResponseMock | Promise<FetchTextResponseMock>
> = new Map();

type GraphQlMockStoreValuesType =
  | GraphQlMockResponseWithUntypedErrors<any>
  | Promise<GraphQlMockResponseWithUntypedErrors<any>>
  | GraphQlMockResponseWithTypedErrors<any, any>
  | Promise<GraphQlMockResponseWithTypedErrors<any, any>>;

export const graphQlMockStore: MockStore<
  GraphQlMockOptions<any>,
  GraphQlMockStoreValuesType
> = new Map();

export const unmockedFetchCallsStore: Set<string> = new Set();
export const readCookies: Map<string, Set<StorageCallback>> = new Map();
export const readLocalStorage: Map<string, Set<StorageCallback>> = new Map();
export const readSessionStorage: Map<string, Set<StorageCallback>> = new Map();

declare global {
  // eslint-disable-next-line no-var, vars-on-top
  var __sdkAfterDataStore: boolean;
}

if (typeof afterEach === 'function' && !globalThis.__sdkAfterDataStore) {
  globalThis.__sdkAfterDataStore = true;

  afterEach(() => {
    fetchMockStore.clear();
    graphQlMockStore.clear();
    unmockedFetchCallsStore.clear();
    readCookies.clear();
    readLocalStorage.clear();
    readSessionStorage.clear();
    unmockedGraphQlOperationsStore.clear();
  });
}
